const Mock = require('mockjs')



 Mock.mock('http://10.91.75.152:8080/search/getdata','get',{

    'items|30': [{
      id: '@id',
      title: '@sentence(10, 20)',
      'status|1': ['published', 'draft', 'deleted'],
      author: 'name',
      display_time: '@datetime',
      pageviews: '@integer(300, 5000)'
    }]
  })
  
